import axios from 'axios';


const http1 = axios.create({
  // baseURL:'http://ec2-18-218-204-87.us-east-2.compute.amazonaws.com/api/v1'
// baseURL:'http://localhost/recursosHumanos/public/api/v1'
// baseURL:'http://127.0.0.1:8000/api/v1'
// baseURL:'https://hr.connectplus.co.mz/public/api/v1'
baseURL:'https://system-api.connecthr.co.mz/api/v1'
});

export default http1;
